import type { RenderOptions } from 'types/unpoly/render'
import { getGeolocation, GeolocationError } from '../util/geolocation'
import type { Up } from 'types/unpoly'

up.compiler('[data-career-search-form]', (form) => {
  async function submitWithGeolocation(renderOptions: RenderOptions) {
    try {
      const { latitude, longitude } = await getGeolocation({
        mayAskForPermission: false,
        timeout: 200,
      })
      ;(renderOptions.params as Up.Params).set('score_via_place', `${latitude},${longitude}`)
    } catch (error) {
      if (!(error instanceof GeolocationError)) {
        throw error
      }
    }

    up.render(renderOptions)
  }

  up.on(form, 'up:form:submit', (event) => {
    const { params, renderOptions } = event
    const cityPlaceParam = params.get('place') && !params.get('place').startsWith('r-')

    if (
      !cityPlaceParam &&
      !params.get('score_via_place') &&
      (params.get('order') === 'score' || !params.get('order'))
    ) {
      void submitWithGeolocation(renderOptions)
      event.preventDefault()
    } else if (cityPlaceParam && params.get('score_via_place')) {
      params.delete('score_via_place')
    }
  })
})
